export const COMMON = {
  NEW_FILTER_TEXT: 'createNewFilterText',
  TOP_ADD_BTN_TEXT: 'addConditionBtnText',
  MUI_BUTTON_BASE_ROOT: 'projectMoreMenuListItem',
  MUI_OUTLINED_INPUT_INPUT: 'deleteProjectDialogBoxInput',
  LIST_WRAPPER: 'moreMenuDropdownItemList',
  DROPDOWN_MENU_ITEM: 'moreMenuDropdownItem',
  TITLE_TEXT: 'projectTypeTitleText',
  MUI_INPUT_BASE_INPUT_ADORNED_END_DATE: 'projectScheduleDateInput',
  MUI_OUTLINED_INPUT_WEEKS: 'projectScheduleInputWeeks',
  MUI_BUTTON_CONTAINED_PRIMARY: 'developerSettingsCloseBtn',
  SIDEBAR_PROJECT_DASHBOARD_BTN_SVG: 'sidebarProjectDashboardBtnIcon',
  SIDEBAR_TIMESPAN_RESOURCES_BTN_SVG: 'sidebarTimespanResourcesBtnIcon',
  APP_ICON: 'appIcon',
  SHARE_PROJECT_BTN: 'shareProjectBtn',
  COMMENTS_BTN: 'commentsBtnTopNav',
  MORE_MENU_BUTTON_TOP_NAV: 'moreMenuButton',
  CANVAS_BOTTOM_TOOLBAR_ZOOM_IN: 'canvasBottomToolbarZoomIn',
  SIDE_NAV_WRAPPER: 'sideNavWrapper',
  CANVAS_BOTTOM_TOOLBAR_ZOOM_OUT: 'canvasBottomToolbarZoomOut',
  LOADING_CIRCULAR_PROGRESS_CONTAINER: 'loading-circular-progress-container',
  LOADING_CIRCULAR_PROGRESS_ANIMATION: 'loading-circular-progress-animation'
} as const;
